/* istanbul ignore file */
import React from 'react';
import { DeleteButton } from 'framework/ui/ui-builder';
import useEmployeeContractsService, {
  DELETE_EMPLOYEE_CONTRACT,
} from 'domain/people/employee/contracts/shared/employeeContractsService';
import {
  useEmployeeContractId,
  useEmployeeContractUrl,
} from 'domain/people/employee/contracts/employeeContractRouting';
import { useCacheService } from 'framework/cache';
import { EMPLOYEES_PATH } from 'domain/shared/employee';
import { ButtonProps } from 'framework/ui/mui-builder';

const DeleteEmployeeContractButton = (props: ButtonProps) => {
  const { getListUrl } = useEmployeeContractUrl();
  const { deleteById } = useEmployeeContractsService();
  const id = useEmployeeContractId();
  const { invalidateCache } = useCacheService(EMPLOYEES_PATH);

  const handleDelete = () => deleteById(id);

  return (
    <DeleteButton
      {...props}
      displayMessage="Do you really want to delete this contract?"
      deleteMethod={handleDelete}
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The contract has been successfully deleted',
        errorMessage: `Can't delete contract`,
        execute: () => {
          invalidateCache();
        },
      }}
      permissionToCheck={DELETE_EMPLOYEE_CONTRACT}
    />
  );
};

export default DeleteEmployeeContractButton;
